import { AttributesMixin, define, Store, type } from "@type-r/models";
import { PaymentPayeesLookup, PaymentPayorsLookup } from "../../api/lookups";
import { PaymentsFilters } from "./payments-filters";

export interface PaymentsStore extends AttributesMixin<typeof PaymentsStore> { }
@define
export class PaymentsStore extends Store {
  static attributes = {
    filter: type(PaymentsFilters),
    payors: PaymentPayorsLookup,
    payees: PaymentPayeesLookup
  }

  initialize() {
    this.filter.payors.set({
        selected: [],
        placeholder: 'Payor Name',
        options: Array.from(new Set(this.payors.items.map(x => x.name)))        
    })
    this.filter.payees.set({
        selected: [],
        placeholder: 'Payee Name',
        options: Array.from(new Set(this.payees.items.map(x => x.name)))        
    })
  }
}  